import { useQuery } from '@tanstack/react-query';
import { fetchSummary } from './fetchSummary';
import { GlobalReactQueryOptions } from '../../config';
import { useDispatch } from 'react-redux';
import { SelectionListOut } from '../../store/api';
import { failSelectionlistSummary, receiveSelectionlistSummary, setActiveList } from '../../store/orderlist/actions';
import { useOrderLists } from '../../shared/common/useOrderLists';
import { browserClient } from '../../react-query';

const QUERY_KEY = 'selectionListSummary';

export const useSelectionListSummary = (listId: string) => {
    const dispatch = useDispatch();
    const { orderlists, activeList } = useOrderLists();

    return useQuery<SelectionListOut>([QUERY_KEY, listId], () => fetchSummary(listId), {
        ...GlobalReactQueryOptions,
        retry: 0,
        onSuccess: orderlist => {
            if (orderlists && activeList && activeList.id === orderlist.id) {
                dispatch(setActiveList(orderlist));
            }
            dispatch(receiveSelectionlistSummary(orderlist));
        },
        onError: e => {
            dispatch(failSelectionlistSummary(e));
        }
    });
};

export const invalidateSelectionListSummary = (listId: string) => {
    return browserClient.invalidateQueries([QUERY_KEY, listId]);
};
